export default {
  id: 'contentblocks',
  idSingular: 'contentblock',
};
